import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Instagram } from "lucide-react";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      toast.success("Welcome to the atelier — use code WELCOME10 for 10% off.");
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not subscribe.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[#F3EFEA] border-t border-[#BCA37F]/25 mt-24" data-testid="site-footer">
      <div className="px-6 md:px-12 lg:px-16 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <p className="font-serif text-3xl tracking-[0.28em]">DABKAZARI</p>
          <p className="mt-4 text-sm text-[#4A4A4A] max-w-md leading-relaxed">
            Handcrafted Indian ethnic wear — anarkalis, lehengas, drape sarees and heirloom pieces
            made by master artisans in dabka and zardozi, shipped worldwide.
          </p>

          <form onSubmit={subscribe} className="mt-8 max-w-md" data-testid="footer-newsletter-form">
            <p className="text-[11px] uppercase tracking-nav text-[#7A7A7A] mb-2">Join the Atelier</p>
            <div className="flex items-end gap-3 border-b border-[#5C1A1B]/50 pb-1">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your email"
                required
                className="flex-1 bg-transparent outline-none text-sm py-2"
                data-testid="footer-newsletter-email"
              />
              <button type="submit" disabled={loading} className="text-[11px] tracking-nav uppercase text-[#5C1A1B] hover:text-[#1A1A1A] transition-colors" data-testid="footer-newsletter-submit">
                {loading ? "…" : "Subscribe"}
              </button>
            </div>
          </form>
        </div>

        <div>
          <p className="text-[11px] uppercase tracking-nav text-[#5C1A1B] mb-4">Shop</p>
          <ul className="space-y-2 text-sm text-[#4A4A4A]">
            <li><a href="/collections/bridal">Bridal</a></li>
            <li><a href="/collections/festive">Festive</a></li>
            <li><a href="/shop/saree">Drape Sarees</a></li>
            <li><a href="/shop/kaftan">Kaftans</a></li>
          </ul>
        </div>
        <div>
          <p className="text-[11px] uppercase tracking-nav text-[#5C1A1B] mb-4">Atelier</p>
          <ul className="space-y-2 text-sm text-[#4A4A4A]">
            <li><a href="/about">Our Story</a></li>
            <li><a href="/blog">Journal & Lookbook</a></li>
            <li><a href="/craft/zardozi">Craftsmanship</a></li>
            <li><a href="/account">Orders & Shipping</a></li>
            <li><a href="mailto:hello@dabkazari.com">Contact</a></li>
          </ul>
        </div>
      </div>

      <div className="px-6 md:px-12 lg:px-16 py-6 border-t border-[#BCA37F]/25 flex flex-col md:flex-row items-center justify-between gap-4 text-[11px] uppercase tracking-nav text-[#7A7A7A]">
        <p>© {new Date().getFullYear()} Dabkazari Atelier. All rights reserved.</p>
        <div className="flex items-center gap-4">
          <a href="#" aria-label="Instagram"><Instagram size={16} strokeWidth={1.4} /></a>
          <span>Made in India · Shipped worldwide</span>
        </div>
      </div>
    </footer>
  );
}
